export default __webpack_public_path__ + "static/media/eye_y.28914846.svg";